import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export function sendRegister(data) {
  return axios.post(`${API_URL}/api/contacts/register`, {
    name: data.name,
    email: data.email,
    message: data.message,
  });
}

export function getContactStatus(email) {
  return axios.get(`${API_URL}/api/contacts/${email}`);
}